import React from "react";
import { Coins } from "lucide-react";
import RaeinWallet from "../components/RaeinWallet";

export default function Token() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-12" data-testid="token-page">
      <div className="mb-8">
        <span className="inline-flex items-center gap-2 text-xs font-mono px-3 py-1 rounded-full bg-amber-500/15 text-amber-400 border border-amber-500/20 mb-4">
          <Coins size={12} /> CRYPTO
        </span>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">Crypto & Wallet</h1>
        <p className="text-zinc-400 mt-2">Collega il tuo wallet, compra e detieni RAEIN direttamente on-chain.</p>
      </div>
      <RaeinWallet />
    </div>
  );
}
